<template>
  <component
    :is="href ? TheNuxtLink : 'button'"
    :to="href"
    class="transition-[padding,border-radius,background-color,color] font-medium"
    :class="{
      'p-2': !small,
      'p-1': small,
      'rounded-md': !pill,
      'rounded-full': pill,
      'bg-opacity-0 dark:bg-opacity-0 canhover:hover:bg-opacity-30 canhover:dark:hover:bg-opacity-30 active:bg-opacity-40 active:dark:bg-opacity-40 canhover:active:bg-opacity-50 canhover:dark:active:bg-opacity-50':
        text,
      disabled,
    }"
  >
    <slot />
  </component>
</template>

<script setup lang="ts">
export type Props = {
  small?: boolean;
  href?: string;
  text?: boolean;
  pill?: boolean;
  disabled?: boolean;
};

defineProps<{
  type?: "primary" | "secondary" | "danger";
  small?: boolean;
  href?: string;
  text?: boolean;
  pill?: boolean;
  disabled?: boolean;
}>();

const TheNuxtLink = resolveComponent("TheNuxtLink");
</script>
